export default function ServicesModifyController(
  $stateParams,
  $state,
  servicesService,
  serviceCategoriesService,
  NotificationService,
  SERVICE_STATUSES,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.serviceItemId = $stateParams.serviceItemId;
  vm.serviceItem = $stateParams.serviceItem;
  vm.categoryId = $stateParams.categoryId;
  vm.serviceStatuses = SERVICE_STATUSES;
  vm.isLoading = false;
  vm.service = {
    categoryId: null,
    name: null,
    description: null,
    priceValue: null,
    sortOrder: 0,
    status: SERVICE_STATUSES.ACTIVE,
  };

  vm.activeTab = 'services';

  init();

  vm.init = init;
  vm.createService = createService;
  vm.updateService = updateService;

  function init() {
    vm.isLoading = true;

    serviceCategoriesService.getServiceCategories().then(function(res) {
      vm.categories = res.data;
      if (vm.serviceItemId && !vm.serviceItem) {
        servicesService
          .getService(vm.merchantId, vm.serviceItemId)
          .then(function(res) {
            vm.service = res.data;
          })
          .finally(function() {
            vm.isLoading = false;
          });
      } else if (vm.serviceItem) {
        vm.service = vm.serviceItem;
        if (vm.service.hasOwnProperty('isActive')) {
          delete vm.service.isActive;
        }
        vm.isLoading = false;
      } else {
        vm.service.categoryId = vm.categoryId;
        vm.isLoading = false;
      }
    });
  }

  function createService() {
    if (vm.isLoading) {
      return;
    }

    vm.isLoading = true;

    servicesService
      .createService(vm.merchantId, vm.service)
      .then(function() {
        goToMerchantServiceList('Service added to merchant');
      })
      .catch(handleError)
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function updateService() {
    if (vm.isLoading || !vm.serviceItemId) {
      return;
    }

    vm.isLoading = true;

    servicesService
      .updateService(vm.merchantId, vm.serviceItemId, vm.service)
      .then(function() {
        goToMerchantServiceList('Service updated');
      })
      .catch(handleError)
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function handleError() {
    NotificationService.error(
      'Error updating service. Please validate that the fields have valid values. ' +
        'The price should be a number separated by a dot, not a comma',
    );
  }

  function goToMerchantServiceList(message) {
    NotificationService.success(message);
    $state.go(
      'app.merchant',
      {
        merchantId: vm.merchantId,
        tab: 'services',
      },
      { reload: true },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/services/services-modify.controller.js